import { WrapPageElementBrowserArgs } from 'gatsby';
import Layout from './components/layout';

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
    return <Layout>{element}</Layout>;
};
